var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgItemTypesManagement = function SvgItemTypesManagement(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.672 21.9351L34.6848 22.0174C34.8525 21.9175 37.731 20.149 36.1383 17.3904C34.7325 14.9555 32.2586 15.9325 31.5804 16.2613L31.4961 16.3034C31.4365 16.3341 31.4043 16.3529 31.4043 16.3529C30.5227 15.3533 29.3341 14.4842 27.8391 13.7446C26.9629 13.298 25.9995 12.9101 24.949 12.581L24.9487 12.5595C24.9422 12.2629 24.7996 9 21.6685 9C18.5374 9 18.4085 12.2629 18.4032 12.5595L18.403 12.581C17.1993 12.8239 15.9613 13.3479 14.6872 14.1534C13.6234 14.7559 12.7405 15.4354 12.0384 16.1917L11.8744 16.3427C11.8591 16.3342 11.8342 16.3207 11.8007 16.3034L11.7164 16.2613C11.0382 15.9325 8.56434 14.9555 7.15856 17.3904C5.59137 20.1048 8.35329 21.8606 8.60188 22.0113L8.61957 22.0219C7.9935 24.8214 8.00897 27.3077 8.666 29.4808L8.69449 29.43C8.70033 29.4477 8.70622 29.4654 8.71217 29.4831C8.71217 29.4831 5.60359 31.2609 7.24367 34.1016C8.82453 36.8398 11.7631 35.2753 11.9711 35.1591C13.5221 36.7984 15.6572 38.044 18.3765 38.8959C18.3765 38.8959 18.0652 42.4672 21.3454 42.4672",
    stroke: "currentColor",
    strokeWidth: 1.761,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M17.5188 29.9346C17.0721 29.4422 17.5108 29.9266 17.5068 29.9227L17.4803 29.8921C15.1673 27.5897 15.1779 23.8717 17.4803 21.5587C17.4867 21.5523 17.4931 21.5459 17.4995 21.5395M17.279 29.6819C18.3373 30.81 19.8415 31.5621 21.3456 31.3749M17.5309 21.5082C19.8391 19.2106 23.5713 19.2138 25.8755 21.5155",
    stroke: "currentColor",
    strokeWidth: 1.761,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7212 28.6363V23.2588C21.7212 22.6981 22.1757 22.2437 22.7363 22.2437H26.9857H34.8825H47.1397C47.7004 22.2437 48.1548 22.6981 48.1548 23.2588V28.6363M21.7212 28.6363V43.7907C21.7212 44.3514 22.1757 44.8058 22.7363 44.8058H47.1397C47.7004 44.8058 48.1548 44.3514 48.1548 43.7907V28.6363M21.7212 28.6363H48.1548",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.738 33.1486L28.8661 34.2767L30.7463 32.0205",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.738 38.4133L28.8661 39.5414L30.7463 37.2852",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0027 33.5244H41.2755",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0027 38.7893H41.2755",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgItemTypesManagement, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/item-types-management.3d240c52.svg";
export { ForwardRef as ReactComponent };